export default __webpack_public_path__ + "static/media/icon-pathwayreport_veggies.58cdece4.png";